<template lang="pug">
  v-container(fluid )
    v-row()
      v-col(cols="12" sm="6")
        .display-1 Contact Us
        ContactForm
      v-col(cols="12" sm="6")
        .display-1 City of Refuge UCC
        .headline 8400 Enterprise Way
        .headline Oakland, CA 94621
        .headline Phone: (510) 633-6316
        .headline Fax: (510) 633-6331
        .headline Email: info@cityofrefugeucc.org
        .headline ContactForm
        v-row(justify="center")
          v-col(cols="12")
            .display-1 Intercessory Prayer - 10:30am
            .display-1 Sunday Service - 11:00am
            .display-1 Bible Study - 1st Tuesdays at 7pm
        v-row(justify="center")
          v-col(cols="12")
            gMap

</template>

<script>
import gMap from '../../components/footer/googleMap';
import ContactForm from '../../components/contact/contactForm';
export default {
  components: {
    ContactForm,
    gMap
  }
};
</script>

<style lang="stylus" scoped></style>
